import React, { Component } from "react";
import styles from "./cmsConnectedSensorChartWrapper.module.scss";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import carStyles from "./../../sections/intellegence/carsIntellegence.module.scss";
import Preloader from "../../../shared/items/static/preloader";
import devicesService from "../../../shared/services/devicesService";
import SensorsChart from "./Charts/SensorsChart";
import ChartSensorsTimeRangeForm from "../../sections/intellegence/ChartSensorsTimeRangeForm";

class CmsConnectedSensorChartWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      carId: null,
    };
  }

  componentDidMount() {
    this.unitByDevice();
  }

  unitByDevice() {
    const { currentDevice } = this.props;

    devicesService
      .unitByDevice(currentDevice.id)
      .then((response) => {
        this.setState({ carId: response.data.id });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { carId } = this.state;

    if (carId === null) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <div className={styles.cmsConnectedSensorChartWrapper}>
        <div className={carStyles.carsIntellegence}>
          <ChartSensorsTimeRangeForm unitId={carId} />
        </div>

        <SensorsChart unitId={carId} />
      </div>
    );
  }
}

export default withCurrentDevices(CmsConnectedSensorChartWrapper);
